const Settings = {
    // url : 'https://hq.dynamicmarkups.com:30502',
    // url : 'http://localhost:3001/attendanceapp',
    // url : 'http://127.0.0.1:30502',
    url : 'https://hq.dynamicmarkups.com/attendanceapp',
    token: ''
}

export default Settings ;